import {
  Header,
  HeaderScrolly,
  Dropdonw,
  LinksDropdonw,
  HeaderScrollyLink,
  HeaderScrollyLinkText,
  KnowMore,
  ButtonCloseModal,
  ModalWrapper,
} from "./style";
import { useEffect, useState } from "react";
import ModalComponent from "../modal";
import React from "react";
import { ImageCustom } from "../Image";
import { listUrl } from "../Data";

const IS_MOBILE = window.innerWidth < 768;

const HeaderComponent = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const [scrollY, setScrollY] = useState(0);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Header>
      <KnowMore onClick={handleOpen}>
        <img src={listUrl.header.burgerheader} alt="logo-arezzo&co" />
      </KnowMore>
      <div className="header__images">
        <img src={listUrl.header.logoheader} alt="" />
        <img
          src="https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/header/id-sustentabilidade.png"
          alt=""
        />
      </div>
      {!IS_MOBILE ? (
        scrollY > 50 ? (
          <HeaderScrolly>
            <HeaderScrollyLink href="#Somos-a-Arezzo">
              <HeaderScrollyLinkText>Somos Arezzo&CO</HeaderScrollyLinkText>
            </HeaderScrollyLink>
            <HeaderScrollyLink href="#Pilares">
              <HeaderScrollyLinkText>Pilares</HeaderScrollyLinkText>
            </HeaderScrollyLink>
            <HeaderScrollyLink href="#Nossos-Compromissos">
              <HeaderScrollyLinkText>Nossos Compromissos</HeaderScrollyLinkText>
            </HeaderScrollyLink>
            <HeaderScrollyLink href="#Politica-de-Sustentabilidade">
              <HeaderScrollyLinkText>
                Política de Sustentabilidade
              </HeaderScrollyLinkText>
            </HeaderScrollyLink>
            <HeaderScrollyLink href="#Relatorio-Anual">
              <HeaderScrollyLinkText>Relatório Anual</HeaderScrollyLinkText>
            </HeaderScrollyLink>
            <HeaderScrollyLink href="#Documentos">
              <HeaderScrollyLinkText>Documentos</HeaderScrollyLinkText>
            </HeaderScrollyLink>
            <HeaderScrollyLink href="#Reconhecimento">
              <HeaderScrollyLinkText>Reconhecimento</HeaderScrollyLinkText>
            </HeaderScrollyLink>
            <HeaderScrollyLink href="#TROC">
              <HeaderScrollyLinkText>TROC</HeaderScrollyLinkText>
            </HeaderScrollyLink>
            <HeaderScrollyLink href="#Marcas">
              <HeaderScrollyLinkText>Grupo e Marcas</HeaderScrollyLinkText>
            </HeaderScrollyLink>
          </HeaderScrolly>
        ) : (
          <Dropdonw>
            <LinksDropdonw href="#Somos-a-Arezzo">
              Somos Arezzo&CO
            </LinksDropdonw>
            <LinksDropdonw href="#Pilares">Pilares</LinksDropdonw>
            <LinksDropdonw href="#Nossos-Compromissos">
              Nossos <br></br>Compromissos
            </LinksDropdonw>
            <LinksDropdonw href="#Politica-de-Sustentabilidade">
              Política de Sustentabilidade
            </LinksDropdonw>
            <LinksDropdonw href="#Relatorio-Anual">
              Relatório Anual
            </LinksDropdonw>
            <LinksDropdonw href="#Documentos">Documentos</LinksDropdonw>
            <LinksDropdonw href="#Reconhecimento">Reconhecimento</LinksDropdonw>
            <LinksDropdonw href="#TROC">TROC</LinksDropdonw>
            <LinksDropdonw href="#Marcas">Grupo e Marcas</LinksDropdonw>
          </Dropdonw>
        )
      ) : (
        ""
      )}
      <ModalComponent open={open} handleClose={handleClose}>
        <ModalWrapper>
          <Dropdonw>
            <LinksDropdonw href="#Somos-a-Arezzo" onClick={handleClose}>
              Somos Arezzo&CO
            </LinksDropdonw>
            <LinksDropdonw href="#Pilares" onClick={handleClose}>
              Pilares
            </LinksDropdonw>
            <LinksDropdonw href="#Nossos-Compromissos" onClick={handleClose}>
              Nossos <br></br>Compromissos
            </LinksDropdonw>
            <LinksDropdonw
              href="#Politica-de-Sustentabilidade"
              onClick={handleClose}
            >
              Política de Sustentabilidade
            </LinksDropdonw>
            <LinksDropdonw href="#Relatorio-Anual" onClick={handleClose}>
              Relatório Anual
            </LinksDropdonw>
            <LinksDropdonw href="#Documentos" onClick={handleClose}>
              Documentos
            </LinksDropdonw>
            <LinksDropdonw href="#Reconhecimento" onClick={handleClose}>
              Reconhecimento
            </LinksDropdonw>
            <LinksDropdonw href="#TROC" onClick={handleClose}>
              TROC
            </LinksDropdonw>
            <LinksDropdonw href="#Marcas" onClick={handleClose}>
              Grupo e Marcas
            </LinksDropdonw>
            <ButtonCloseModal onClick={handleClose}>
              <img src={listUrl.header.closemodal} alt="logo-arezzo&co" />
            </ButtonCloseModal>
          </Dropdonw>
        </ModalWrapper>
      </ModalComponent>
    </Header>
  );
};

export default HeaderComponent;
